import React from "react";
import "./Hero.css";
import gold_earrings_upscaled from "../gold_earrings_upscaled.jpg"; 
export default function Hero() {
  return (
    <section className="hero">
      <div className="hero__content">
        <h1 className="hero__headline">
          <span className="hero__headline-gold">
           Into Instant
            <br />
            Cash
          </span>
          <span className="hero__headline-white">You Can Trust</span>
        </h1>

        <p className="hero__subtext">
          State-of-the-art testing technology, fully transparent valuation and{" "}
          <span className="hero__highlight">100% safe, guaranteed payouts.</span>{" "}
          Sell your used gold for cash the royal way — swift, honest and
          hassle-free.
        </p>

        <div className="hero__actions">
          <button className="hero__btn hero__btn--primary">
            Get Instant Cash Quote
          </button>
          <button className="hero__btn hero__btn--secondary">
            Estimate My Gold
          </button>
        </div>
      </div>

      <div className="hero__media">
        <div className="hero__image-frame">
          <img
            className="hero__image"
             src={gold_earrings_upscaled} 
            alt="Gold earrings on black fabric"
          />

          <div className="hero__price-tag">
            <p className="hero__price">
              <span className="hero__rupee">₹</span>7,450
              <span className="hero__price-unit">/g</span>
            </p>
            <p className="hero__price-label">Indicative 24K rate today</p>
          </div>

          <div className="hero__live-badge">
            <span className="hero__live-dot" />
            Live valuation
          </div>
        </div>
      </div>
    </section>
  );
}